import { Article, Pin, PinDrop } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { VoyageFormField } from "./VoyageFormField";

export const VoyageLocations = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <PinDrop style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Locations")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <VoyageFormField label={t("AgentPortLocation")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Location" filterField={'LocationName'} labelFields={['LocationName']} extraFields={[{key: 'Id', value: 'IdAgentPortLocation'}, {key: 'LocationName', value: 'AgentPortLocationName'}]} code="AgentPortLocationName"  data={dataState} setData={setDataState} />
            <VoyageFormField label={t("StartPortLocation")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Location" filterField={'LocationName'} labelFields={['LocationName']} extraFields={[{key: 'Id', value: 'IdStartPortLocation'}, {key: 'LocationName', value: 'StartPortLocationName'}]} code="StartPortLocationName"  data={dataState} setData={setDataState} />
            <VoyageFormField label={t("PreviousPortLocation")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Location" filterField={'LocationName'} labelFields={['LocationName']} extraFields={[{key: 'Id', value: 'IdPreviousPortLocation'}, {key: 'LocationName', value: 'PreviousPortLocationName'}]} code="PreviousPortLocationName"  data={dataState} setData={setDataState} />
            <VoyageFormField label={t("NextPortLocation")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Location" filterField={'LocationName'} labelFields={['LocationName']} extraFields={[{key: 'Id', value: 'IdNextPortLocation'}, {key: 'LocationName', value: 'NextPortLocationName'}]} code="NextPortLocationName"  data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}
